import { useState } from 'react'

import { brandingTabs } from '@/configuration/pages/ConfigurationPage/ThemeConfiguration/constants'

const useBrandingTabs = () => {
  const [activeTab, setActiveTab] = useState(brandingTabs.brandAndImages)
  const [tabErrors, setTabErrors] = useState({})
  const [subTabErrors, setSubTabErrors] = useState({})

  const handleChangeTab = tab => {
    setActiveTab(tab)
  }

  const setTabError = (tab, hasError) => {
    setTabErrors(prev => ({ ...prev, [tab]: hasError }))
  }

  const setSubTabError = (subTab, hasError) => {
    setSubTabErrors(prev => ({ ...prev, [subTab]: hasError }))
  }

  const clearTabErrors = () => {
    setTabErrors({})
    setSubTabErrors({})
  }

  return {
    activeTab,
    handleChangeTab,
    tabErrors,
    setTabError,
    subTabErrors,
    setSubTabError,
    clearTabErrors,
  }
}

export default useBrandingTabs
